import { EnhancedHeartGame } from "@/components/KarishaMain";

// Главная страница приложения
const Index = () => {
  return <EnhancedHeartGame />; // Отображаем улучшенную игру с сердечками
};

export default Index;
